import PropTypes from "prop-types";
import Header from "../Header";
import Footer from "../Footer";
import { useProviderContext } from "components/Provider/ProviderContext";
import { useEffect } from "react";
import { useLocation } from "react-router";
import RedirectModal from "components/Modal/RedirectModal";
import { useTranslation } from "react-i18next";

const hideHeaderPathnames = ["/", "/order-result"];

function Layout(props: { children: any }): JSX.Element {
  const { t } = useTranslation();
  const { children } = props;
  const { AppState, CheckoutState } = useProviderContext();
  const location = useLocation();

  const updateMedia = () => {
    setTimeout(() => AppState.sendEvent("SET_IS_DESKTOP"), 100);
  };

  useEffect(() => {
    window.addEventListener("resize", updateMedia);
    return () => window.removeEventListener("resize", updateMedia);
  });

  return (
    <>
      <div className="layout-default">
        <div className="layout-body">
          <div className="layout-wrapper">
            {(hideHeaderPathnames.indexOf(location.pathname) === -1 ||
              !AppState.context.isDesktop) && <Header />}
            <div
              id="scroll-top-anchor"
              className="layout-wrapper-inner hide-scrollbar-indicator"
            >
              <div className="layout-default-content">{children}</div>
            </div>
            <Footer />
          </div>
        </div>
      </div>

      <RedirectModal
        open={CheckoutState.matches("redirecting")}
        onClose={() => CheckoutState.sendEvent("CLOSE")}
        message={t("redirect_modal_message")}
      />
    </>
  );
}

Layout.propTypes = {
  children: PropTypes.object,
};

export default Layout;
